import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { SharedService } from '../../../../shared/services/shared.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { environment } from '../../../../../environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing-banner',
  standalone: true,
  imports: [
    CommonModule, TranslateModule, MatButtonModule
  ],
  templateUrl: './landing-banner.component.html',
  styleUrl: './landing-banner.component.scss'
})
export class LandingBannerComponent {
  resellerSettingsContext: any;
  data: any = [];
  @ViewChild('carousel', { static: false }) private _carousel!: ElementRef;
	carouselConfiguration!: string;

  constructor(
    private sharedService: SharedService,
		private router: Router,
  ) {
    this.sharedService.resellerSettingsContext.pipe(takeUntilDestroyed()).subscribe({
			next: response => {
				this.resellerSettingsContext = response;
        this.carouselConfiguration = JSON.stringify(this.resellerSettingsContext.banner.configuration);
				this.data = this.resellerSettingsContext.home.data;
			},
		});
  }

  navigateToPage(routerLink: string){
      this.router.navigate([routerLink]);
  }
}
